<!-- Ship Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Ship Listing Component -->
  <app-ship-listing #shipListing>
  </app-ship-listing>
</div>

<!-- Ship Add/Edit Modal -->
<app-ship-add-edit
  (shipAdded)="onShipAdded()"
  (shipUpdated)="onShipUpdated()">
</app-ship-add-edit>
